import React from 'react';

import ScrollEvent from '../shared/components/scroll-event';
import { withError } from '../shared/components/error-boundary';
import AccessibleElement from '../ui/components/accessible-element';
import withWindowResize from '../ui/components/window-resize';
import { ModalControl } from '../context/modal/modal-context';

import './css/left-menu.less';

const MobileMenu = props => {
    const { tabs, activeTabTitle, tabClick, setVisibility, setActiveTab, closeModal } = props;

    return (
        <div className={`left-menu-modal`}>
            <InnerMenu
                tabs={tabs}
                activeTabTitle={activeTabTitle}
                tabClick={tabClick}
                setVisibility={setVisibility}
                setActiveTab={setActiveTab}
                closeModal={closeModal}
            />
        </div>
    );
};

const InnerMenu = props => {
    const { tabs, activeTabTitle, tabClick, setVisibility, setActiveTab, closeModal, minTabs } = props;
    const showTabs = tabs.length >= minTabs;
    return (
        <div className="hover-scroll-inner left-menu-inner">
            {showTabs && (
                <ul className="menu-tabs clearfix">
                    {tabs.map((tab, i) => {
                        return (
                            <AccessibleElement
                                key={i}
                                element="li"
                                className={activeTabTitle === tab.title ? 'active' : ''}
                                onClick={tabClick(tab.title)}
                                style={{ width: `${100 / tabs.length}%` }}
                                ariaLabel={tab.title}
                            >
                                {tab.title}
                            </AccessibleElement>
                        );
                    })}
                </ul>
            )}
            {tabs.map((tab, i) => {
                let { Component, tabProps = {} } = tab;
                const active = activeTabTitle === tab.title;
                return (
                    <div className={`tab-content${active ? ' active' : ''}`} key={i}>
                        <Component
                            isActiveTab={active}
                            setActiveTab={setActiveTab}
                            setVisibility={setVisibility}
                            leftMenuTabCount={tabs.length}
                            closeModal={closeModal}
                            {...tabProps}
                        />
                    </div>
                );
            })}
        </div>
    );
};

class LeftMenuV2 extends React.PureComponent {
    //static whyDidYouRender = true;
    static defaultProps = {
        botBound: '.products-list',
        className: '',
        scrollClassName: '',
        tabs: [],
        lockMenu: false,
        minTabs: 1,
        hideMobile: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            activeTabTitle: (this.props.tabs.filter(tab => tab.active)[0] || {}).title,
        };
        if (props.defaultVisibility) {
            this.setVisibility(props.defaultVisibility);
        }
    }

    componentDidUpdate(prevProps) {
        //if active tab does not exist in list, activate first tab
        const { tabs } = this.props;
        const { activeTabTitle } = this.state;
        const activeTab = activeTabTitle && tabs.find(t => t.title === activeTabTitle);

        if (tabs.length > 0 && (!activeTabTitle || !activeTab || prevProps.tabs.length !== tabs.length)) {
            this.setState({
                activeTabTitle: (this.props.tabs.filter(tab => tab.active)[0] || {}).title,
            });
        }
    }

    menuSticky = (isSticky, botReached) => {
        if (botReached) {
            return ' left-menu-bottom';
        } else if (isSticky) {
            return ' fixed-left-menu';
        } else {
            return '';
        }
    };

    setVisibility = isVisible => {
        const { dispatchMenuState, menuID } = this.props;
        dispatchMenuState(isVisible, menuID);
    };

    setActiveTab = tabTitle => {
        const { tabs } = this.props;
        if (this.state.activeTabTitle != tabTitle) {
            this.setState({
                activeTabTitle: tabTitle,
            });
        }
    };

    componentWillUnmount() {
        const { leftMenuActive, dispatchMenuState, lockMenu } = this.props;
        if (leftMenuActive && !lockMenu) {
            dispatchMenuState(!leftMenuActive);
        }
    }

    tabClick = tabTitle => {
        return () => {
            this.setActiveTab(tabTitle);
        };
    };

    mobileClick = tab => {
        return () => {
            if (this.state.activeTabTitle != tab.title) {
                this.setState({
                    activeTabTitle: tab.title,
                });
            }
        };
    };

    openModal = (tabTitle, openModal) => {
        return () => {
            this.setActiveTab(tabTitle);
            openModal();
        };
    };

    render() {
        const {
            botBound,
            className,
            scrollClassName,
            tabs,
            device,
            leftMenuActive,
            sticky = true,
            lockMenu,
            minTabs,
            hideMobile,
        } = this.props;
        const { activeTabTitle } = this.state;

        if (device === 'desktop') {
            return (
                <ScrollEvent botBound={botBound} disableScroll={!sticky}>
                    {(attachRef, scrollState) => {
                        const { botReached, isSticky } = scrollState;

                        const wrapperClassNames = [
                            'left-menu',
                            botReached ? 'static-container' : '',
                            leftMenuActive ? 'show' : '',
                            sticky ? 'sticky-menu' : '',
                            className,
                        ];

                        const hoverScrollClassNames = sticky
                            ? ['hover-scroll', this.menuSticky(isSticky, botReached), scrollClassName]
                            : [];

                        return (
                            <div ref={attachRef} className={wrapperClassNames.join(' ')}>
                                <div className={hoverScrollClassNames.join(' ')}>
                                    <InnerMenu
                                        tabs={tabs.filter(({ mobileOnly }) => !mobileOnly)}
                                        minTabs={minTabs}
                                        activeTabTitle={activeTabTitle}
                                        tabClick={this.tabClick}
                                        setVisibility={!lockMenu ? this.setVisibility : undefined}
                                        setActiveTab={this.setActiveTab}
                                    />
                                </div>
                            </div>
                        );
                    }}
                </ScrollEvent>
            );
        } else if (!hideMobile) {
            let modalMenu = {
                tabs,
                activeTabTitle,
                tabClick: this.tabClick,
                setVisibility: this.setVisibility,
                setActiveTab: this.setActiveTab,
            };
            return (
                <ModalControl
                    content={modalProps => {
                        return <MobileMenu {...modalProps} {...modalMenu} />;
                    }}
                    atomic={true}
                >
                    {props => {
                        return (
                            <div className={`left-menu-mobile${leftMenuActive ? ' show' : ''} `}>
                                {tabs.map((tab, i) => {
                                    if (tab.mobileTab) {
                                        return (
                                            <span
                                                className={`left-menu-mobile-btn`}
                                                style={{ width: `${100 / tabs.length}%` }}
                                                key={i}
                                            >
                                                {tab.mobileTab()}
                                            </span>
                                        );
                                    }
                                    return (
                                        <span
                                            className={`left-menu-mobile-btn`}
                                            style={{ width: `${100 / tabs.length}%` }}
                                            key={i}
                                            onClick={this.openModal(tab.title, props.openModal)}
                                        >
                                            {tab.title}
                                        </span>
                                    );
                                })}
                            </div>
                        );
                    }}
                </ModalControl>
            );
        } else {
            return null;
        }
    }
}

export default withError(withWindowResize(LeftMenuV2));
